import { render, staticRenderFns } from "./ProgressPlanet.vue?vue&type=template&id=4cd679da&"
import script from "./ProgressPlanet.vue?vue&type=script&lang=ts&"
export * from "./ProgressPlanet.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressPlanet.vue?vue&type=style&index=0&id=4cd679da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports